// volto-tenant-baseline — the GUIDE-PLATFORM-001 §6.1 mandatory fleet
// baseline as ONE shared addon (CR-2026-077 / DR-2026-272), plus the fleet
// Guides navigation element (marketing-tutorial delivery decision, s527).
//
// Split of responsibilities (load-order constraint, AIV-2026-024 class):
//  - This applyConfig runs when the addon loads — BEFORE VLT (the addon sits
//    before @kitconcept/volto-light-theme in every tenant's addons[]; VLT
//    stays LAST). It therefore only sets SAFE DEFAULTS. It must NEVER
//    register slot components here: VLT's own headerTools registration runs
//    later and would silently win.
//  - applyTenantBaseline(config, overrides) carries the registrations that
//    must OUTRANK VLT's. The tenant addon (outermost; its applyConfig runs
//    after all inner addons) calls it — one line per tenant, logic versioned
//    once here.
//  - The LanguageSelector shadow (src/customizations/) and the 880px token
//    (src/theme/_main.scss) apply via addons[] membership automatically.

import { applyTenantBaseline } from './applyTenantBaseline';

const applyConfig = (config) => {
  // Guides-commons integration defaults (DR-2026-272). Tenants override
  // individual keys in their own applyConfig (which runs later), e.g.
  //   config.settings.tenantBaseline = {
  //     ...config.settings.tenantBaseline, guidesSectorPath: '/medical' };
  config.settings.tenantBaseline = {
    guidesUrl: 'https://guides.ljusa-tider.se',
    guidesSectorPath: '',
    guidesLabel: null, // null => i18n default ("Guides")
    guidesLanguageMap: true,
    // Language roots live on the commons today. Widening this list when the
    // commons gains languages is ONE addon bump, fleet-wide (version-once).
    guidesLanguages: ['en'],
    // Return navigation (DR-2026-272 s529 wave): a tenant that declares a
    // tenantKey sends ?from=<key> with its Guides entry; the commons-side
    // ReturnLink resolves the key against fleetRegistry and renders
    // "← <label>". Public origins + display labels ONLY; origins read from
    // TENANT_REGISTRY (tools/mcp_hetzner.py) at authoring time, never typed
    // from memory. A tenant joins the registry when its migration wave
    // lands — one addon bump, fleet-wide (version-once).
    tenantKey: null,
    isCommons: false,
    fleetRegistry: {
      wantai: { origin: 'https://wantai.ljusa-tider.se', label: 'Wantai' },
      yizhou: { origin: 'https://yizhou.ljusa-tider.se', label: 'YiZhou' },
    },
    ...(config.settings.tenantBaseline || {}),
  };
  return config;
};

export default applyConfig;
export { applyTenantBaseline };
